import React from 'react';

const SchoolInfo = ({ schoolName, fillForm }) => {
  return (
    <>
      <h4 className="text-2xl my-3 font-medium school-info">
        SCHOOL INFORMATION
      </h4>
      <input
        type="text"
        name="schoolName"
        value={schoolName}
        onChange={fillForm}
        className="bg-stone-50 rounded-lg p-3 w-full"
        placeholder="Name of School"
      />
    </>
  );
};

export default SchoolInfo;
